import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  rootContainer: {
    justifyContent: 'center',
    marginTop: theme.spacing(2.5),
  },
  rootItem: {
    backgroundColor: '#eee9',
    borderRadius: '8px',
    paddingTop: '5%',
  },
  labelContainer: {
    padding: '10px 10px',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  dateRangeBtn: {
    color: 'black',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '15px',

    // margin: 'auto',
    // padding: '0px 3px',
  },
  autocomplete: {
    // width: '248px',
    width: '70%',
    padding: '10px 10px',
  },
  textField: {
    width: '70%',
    padding: '10px 10px',
  },
  submitContainer: {
    paddingTop: '6px',
    textAlign: 'center',
    paddingBottom: '3%',
  },
  dateRangeModal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '648px',
    backgroundColor: theme?.palette?.background?.paper,
    boxShadow: theme?.shadows?.[24],
    borderRadius: '10px',
    padding: theme?.spacing(4),
  },
  customAutoComplete: {
    width: '20%',
  },
}));
